// Holds the short-lived access token in memory only.
// It is never written to localStorage/sessionStorage, so injected scripts can't read it from storage,
// and it disappears when the tab closes. The long-lived refresh token lives in an httpOnly cookie
// set by the backend, which JavaScript can't read at all.

let accessToken = null;
let expiresAt = 0;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn({ accessToken, expiresAt }));

const tokenStore = {
  get: () => (accessToken && (!expiresAt || Date.now() < expiresAt) ? accessToken : null),
  expiresAt: () => expiresAt,
  set(token, expiresInSeconds) {
    accessToken = token || null;
    expiresAt = token && Number(expiresInSeconds) > 0 ? Date.now() + Number(expiresInSeconds) * 1000 : 0;
    notify();
  },
  clear() {
    accessToken = null;
    expiresAt = 0;
    notify();
  },
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

export default tokenStore;
